import React, { FC, ReactNode } from 'react';
import { Box, Divider, Link, Stack } from '@mui/material';
import styled from 'styled-components';

import { PVBlack } from '@pv/common/colors';

import { FooterBar } from './FooterBar';

/*
 * Types.
 */

interface ProfileFooterProps {}

interface ProfileFooterLinkProps {
  href: string;
  color?: string;
  children: ReactNode;
}

/*
 * Constants.
 */

const StyledAboutStack = styled(Stack)({
  gap: '10px',
});

const ProfileFooterLink: FC<ProfileFooterLinkProps> = ({
  href,
  children,
  color = PVBlack,
}) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener,noreferrer"
    variant="body1"
    underline="hover"
    color={color}
  >
    {children}
  </Link>
);

/*
 * Components.
 */

export const ProfileFooter: FC<ProfileFooterProps> = () => (
  <Stack>
    <Stack direction="row" sx={{ padding: '16px 0px 48px' }}>
      <Stack
        direction={{ sm: 'column', md: 'row' }}
        gap="32px"
        width={{ sm: 'auto', md: '100%' }}
        sx={{ justifyContent: 'space-between' }}
      >
        <Stack>
          <Box
            component="img"
            alt="Perfect Venue Logo"
            src="/pv-logo-marketplace.png"
            height="32px"
          />
        </Stack>

        <StyledAboutStack>
          <ProfileFooterLink href="https://app.perfectvenue.com/users/sign_up">
            List your Venue
          </ProfileFooterLink>
        </StyledAboutStack>
      </Stack>
    </Stack>
    <Divider />
    <FooterBar />
  </Stack>
);
